import { IProductType } from '../types/product-type.type';

export const PRODUCT_TYPE_LIST = Object.values(IProductType);
